import React from 'react';

function CloseCircle(props) {
    const className = props.className;
    const clickFunc = props.clickFunc;
    const fill = props.fill;
    return (
        <svg 
            width="32" 
            height="32" 
            viewBox="0 0 32 32" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            onClick={() => clickFunc()}
        >
            <circle 
                cx="16" 
                cy="16" 
                r="11.5" 
                fill={fill} 
                fillOpacity="0.5" 
                stroke="#FAFAFA"
            />
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M13.3098 12.1847C13.1035 11.9556 12.7506 11.9371 12.5216 12.1434C12.2925 12.3496 12.274 12.7025 12.4803 12.9315L15.2492 16.0067L12.4924 19.0684C12.2861 19.2975 12.3046 19.6504 12.5337 19.8566C12.7628 20.0629 13.1156 20.0444 13.3219 19.8153L16.0002 16.8408L18.6785 19.8153C18.8847 20.0444 19.2376 20.0629 19.4666 19.8566C19.6957 19.6504 19.7142 19.2975 19.508 19.0684L16.7512 16.0067L19.5201 12.9316C19.7263 12.7025 19.7078 12.3496 19.4788 12.1434C19.2497 11.9371 18.8968 11.9556 18.6906 12.1847L16.0002 15.1727L13.3098 12.1847Z" 
                fill="#FAFAFA"
            />
        </svg>
    )
};

export default CloseCircle;